import { useMutation } from '@tanstack/react-query';
import {
  inviteOrAddExternalToProject,
  type InviteOrAddExternalInput,
  type InviteOrAddExternalResponse,
} from '../services/api/externalInvites';

export interface UseInviteExternalInput extends InviteOrAddExternalInput {
  projectId: number;
}

/**
 * PM-driven kanban invite mutation. No optimistic cache patch — the only
 * server-visible side-effect that the kanban cares about is "external user
 * gains/loses access to this project," which doesn't change the board
 * columns/tasks the page is rendering, so there's nothing to invalidate.
 *
 * Caller is expected to surface the resulting `action` to the user (e.g.,
 * "Invite sent" vs "User added").
 */
export function useInviteExternalToProject() {
  return useMutation<InviteOrAddExternalResponse, Error, UseInviteExternalInput>({
    mutationFn: ({ projectId, ...input }) =>
      inviteOrAddExternalToProject(projectId, input),
  });
}
